"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "detail-checkbox-label" };
const _hoisted_2 = { class: "input-box" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "text" };
const CustomInput_vue_1 = __importDefault(require("../../components/frontend/CustomInput.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'DetailSmallCheckbox',
    props: {
        inputName: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(CustomInput_vue_1.default, {
                        type: "checkbox",
                        name: __props.inputName
                    }, null, 8, ["name"]),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(__props.title), 1)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(__props.text), 1)
            ]));
        };
    }
});
